<template>
  <div ref="accountApiHistoryTable" class="api-active-solver-graph">
    <div class="api-active-solver-graph-column">
      <div class="api-active-solver-header">
        <div>
          <h1>API Request History</h1>
          <p>An overview of your API requests.</p>
        </div>
        <div>
          <p @click="refresh" style="cursor: pointer">REFRESH</p>
        </div>
      </div>
      <div class="api-actual-table-header">
        <div class="api-actual-table-header-container">
          <div class="api-actual-table-header-id">ID</div>
          <div class="api-actual-table-header-timedate">Time/Date</div>
          <div class="api-actual-table-header-url">URL</div>
          <div class="api-actual-table-header-mode">Mode</div>
          <div class="api-actual-table-header-solvetime">Solve Time</div>
          <div class="api-actual-table-header-balance">Balance</div>
        </div>
      </div>
      <div class="api-actual-table">
        <div v-if="isLoaded">
          <div v-if="apiRequests.length > 0">
            <div
              v-for="(record, key) in apiRequests"
              :key="key"
              class="api-actual-table-item"
            >
              <div class="api-actual-table-item-container">
                <div class="api-actual-table-item-id">{{ key + 1 }}</div>
                <div class="api-actual-table-item-timedate">
                  {{ record.time }}
                </div>
                <div class="api-actual-table-item-url">
                  <p>{{ record.url.substr(0, 60) }}...</p></div>
                <div class="api-actual-table-item-mode">{{ record.mode }}</div>
                <div class="api-actual-table-item-solvetime">
                  {{ record.solveTime }} sec
                </div>
                <div class="api-actual-table-item-balance">
                  $ {{ record.balance }}
                </div>
              </div>
            </div>
            <div class="load-more">
              <p @click="loadMore">Load More</p>
            </div>
          </div>
          <div v-else class="full-width">No Data Found!</div>
        </div>
        <div class="full-width" v-else>Loading...</div>
      </div>
    </div>
  </div>
</template>

<script>
import { handleGetApiRequestHistory } from "../../../../service/user";
export default {
  data() {
    return {
      page: 1,
      isLoaded: false,
      apiRequests: [],
    };
  },
  async mounted() {
    await this.sleep(80);
    this.$refs.accountApiHistoryTable.style = "transform: scale(1) !important";
    const response = await handleGetApiRequestHistory(this.page);
    this.apiRequests = response.data.data.requests;
    this.isLoaded = true;
  },
  methods: {
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    async refresh() {
      this.isLoaded = false;
      this.apiRequests = [];
      const response = await handleGetApiRequestHistory(this.page);
      this.apiRequests = response.data.data.requests;
      this.isLoaded = true;
    },
    async loadMore() {
      this.isLoaded = false;
      this.page++;
      const response = await handleGetApiRequestHistory(this.page);
      // console.log(response.data.data);
      this.apiRequests = [...this.apiRequests, ...response.data.data.requests];
      this.isLoaded = true;
    },
  },
};
</script>

<style>
.full-width {
  display: flex;
  justify-content: center;
  height: 100%;
  align-items: center;
}

.load-more {
  display: flex;
  justify-content: center;
  height: 100%;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
}
.load-more > p {
  cursor: pointer;
}
.api-active-solver-graph {
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-height: 650px;
  max-width: 100%;
  width: 100%;
  height: 650px;
  background: radial-gradient(
    100% 100% at 44.04% 0%,
    #26292e85 0%,
    #1a1c1f 100%
  );
  mix-blend-mode: normal;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.0835883), inset 0px 1px 3px #000000;
  border-radius: 7px;

  margin-bottom: 24px;
  transform: scale(0.5);
  transition: 0.4s;
}
.api-active-solver-graph-column {
  margin: 15px;
  height: 95%;
  width: 95%;
}

.api-active-solver-header {
  display: flex;
  justify-content: space-between;
}

.api-active-solver-header > div:nth-of-type(odd) {
  display: flex;
  flex-direction: column;
}
.api-active-solver-header > div:nth-of-type(odd) > h1 {
  color: #e0e0e0;
  font-size: 20px;
  font-family: "OpenSans";
}
.api-active-solver-header > div:nth-of-type(odd) > p {
  color: #888888;
  font-size: 12px;
}
.api-active-solver-header > div:nth-of-type(even) > p {
  color: #888888;
  font-size: 10px;
}

.api-actual-table-header {
  display: flex;
  margin-top: 20px;
  color: #888888;
  font-family: "OpenSans-Bold";
  width: 100%;
  justify-content: space-evenly;
}

.api-actual-table-header-container {
  width: 90%;
  display: flex;
}

.api-actual-table-header-id {
  flex: 0.1;
}
.api-actual-table-header-timedate {
  flex: 0.2;
}
.api-actual-table-header-mode {
  flex: 0.1;
}
.api-actual-table-header-url {
  flex: 0.4;
  display: flex;
  padding-left: 40px;
}
.api-actual-table-header-solvetime {
  flex: 0.1;
}
.api-actual-table-header-balance {
  flex: 0.1;
  display: flex;
  justify-content: flex-end;
}

.api-actual-table-item-id {
  flex: 0.1;
}
.api-actual-table-item-timedate {
  flex: 0.2;
}
.api-actual-table-item-mode {
  flex: 0.1;
}
.api-actual-table-item-url {
  flex: 0.4;
  display: flex;
  justify-content: flex-start;
  padding-left: 20px;
  padding-right: 20px;
  max-width: 40%;
  overflow: hidden;
}
.api-actual-table-item-solvetime {
  flex: 0.1;
}
.api-actual-table-item-balance {
  flex: 0.1;
  display: flex;
  justify-content: flex-end;
}
.api-actual-table {
  background-color: #131517;
  height: 480px;
  margin-top: 5px;
  border-radius: 10px;
  overflow-x: auto;
  padding: 20px;
}
.api-actual-table-item {
  height: 45px;
  width: 100%;
  background: radial-gradient(
    100% 100% at 44.04% 0%,
    rgba(38, 41, 46, 0.5) 0%,
    #1a1c1f 100%
  );
  mix-blend-mode: normal;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.0835883);
  border-radius: 10px;
  display: flex;
  justify-content: space-evenly;
  margin-top: 10px;
  min-width: 700px;
}

.api-actual-table-item-container {
  width: 93.5%;
  display: flex;
  align-items: center;
  height: 100%;
  font-size: 12px;
  color: #888888;
}
</style>
